import { AutogenModelOtherChargeRate, AutogenRowOtherChargeRate } from "./autogen/AutogenModelOtherChargeRate";

export class ModelOtherChargeRate extends AutogenModelOtherChargeRate<RowOtherChargeRate> {
	constructor() {
		super(RowOtherChargeRate);
	}
}

export class RowOtherChargeRate extends AutogenRowOtherChargeRate {
}